import script from "./ImpostorSilhouetteCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ImpostorSilhouetteCard.vue?vue&type=script&setup=true&lang=js"

import "./ImpostorSilhouetteCard.vue?vue&type=style&index=0&id=6a3c7f77&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a3c7f77"]])

export default __exports__